const featureSet = ['maven.feature.new.ccsV2'];
const localStorageKeys = ['policy-logs-visited', 'intent-content-policies-visited'];

export interface ShowNewTagOptions {
  isCcsV2?: boolean;
}

const hasAllFeatures = (
  features: { [key: string]: boolean } | null,
): boolean => {
  let contains = true;
  featureSet.forEach((it: string) => {
    if (!features?.[it]) {
      contains = false;
    }
  });
  return contains;
};

const hasAllLocalStorage = (): boolean => {
  let hasKey = true;
  localStorageKeys.forEach((it: string) => {
    if (localStorage.getItem(it) !== 'true') {
      hasKey = false;
    }
  });
  return hasKey;
};

const showNewTag = (
  routeName: string,
  features: { [key: string]: boolean },
  options: ShowNewTagOptions = {},
): boolean => {
  switch (routeName) {
    case '/policy-logs':
    case '/intent-content-policies':
      return !!options.isCcsV2 && hasAllFeatures(features) && !hasAllLocalStorage();
    default:
      return false;
  }
};

const showAnnouncementButton = (
  features: { [key: string]: boolean } | null,
  options: ShowNewTagOptions = {},
): boolean => (!!options.isCcsV2 && hasAllFeatures(features) && !hasAllLocalStorage());

const clearFeatureSetFromLocalStorage = () => {
  featureSet.forEach((feature) => localStorage.removeItem(feature));
};

export {
  showNewTag,
  showAnnouncementButton,
  clearFeatureSetFromLocalStorage,
};
